.amount {
  font-weight: 500;
}

.comment {
  max-width: 80%;
}
